import { useEffect, useState } from 'react';
import { MessageDescriptor, PrimitiveType, useIntl } from 'react-intl';
import { ObjectSchema } from 'yup';

export type FormatMessageType = (descriptor: MessageDescriptor, values?: Record<string, PrimitiveType>) => string;

function useValidation<T extends object>(
  constructSchema?: (formatMessage: FormatMessageType) => ObjectSchema<Partial<T>>,
) {
  const { formatMessage } = useIntl();
  const [validationSchema, setValidationSchema] = useState<ObjectSchema<Partial<T>>>();

  useEffect(() => {
    setValidationSchema(constructSchema?.(formatMessage));
  }, [formatMessage, constructSchema]);

  return validationSchema;
}

export default useValidation;
